import dayjs from 'dayjs'
import { EventResponseItem, EventItem } from '@/types/Event'
import * as eventUtils from '@/utils/eventUtils'
import * as wpRestApiUtils from '@/utils/wpRestApiUtils'

export function convertEventItem(event: EventResponseItem): EventItem {
  return {
    id: event.id,
    link: `/events/detail/${event.id}`,
    title: event.title.rendered,
    tags: eventUtils.getEventTags(event),
    categoryName: eventUtils.getEventCategoryName(event.event_category),
    eventTypes: eventUtils.getEventTypes(event),
    startDate: dayjs(event.acf.event_term.start).format('YYYY-MM-DDTHH:mm:ss'),
    endDate: dayjs(event.acf.event_term.end).format('YYYY-MM-DDTHH:mm:ss'),
    displayTerm: eventUtils.getEventDisplayTerm(
      event.acf.event_term.start,
      event.acf.event_term.end
    ),
    placeName: eventUtils.getEventPlaceName(event),
    placeDetail: event.acf.event_place,
    thumbnailUrl: wpRestApiUtils.getWpThumbnailUrl(event.thumbnail),
    hospitalIds:
    // オンラインイベント
    !!event.acf.event_programs && event.acf.event_programs.length> 0?[
      ...new Set(
        event.acf.event_programs
          .map((program) => program.item.map((el) => el.hospital_id))
          .flat()
      )
    ]:
    // オフラインイベント
    !!event.acf.event_entry_hospitals && event.acf.event_entry_hospitals.length> 0?[
      ...new Set(
        event.acf.event_entry_hospitals
          .map((hospital) => hospital.hospital_id)
      )
    ]:[]
    ,
    seminar:
      Array.isArray(event.acf.event_seminar) &&
      event.acf.event_seminar.length > 0
        ? event.acf.event_seminar
        : []
  }
}
